import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';

export const fileKey = ['charts'];

const useFlowCharts = () => useQuery({
  queryKey: fileKey,
  queryFn: () => agent.getClient().get('file-data/static?tag=charts', {
    responseType: 'arraybuffer',
  }).then(
    (response) => response.data,
  ),
});

export default useFlowCharts;
